(function () {
	'use strict';

	angular.module('app.dashboard')
	.config(leanProjectSummaryConfig);

	function leanProjectSummaryConfig(dashboardProvider) {
		dashboardProvider
			.widget('leanProjectSummary',
				{
					name: 'Lean Project Summary',
					description: 'Configurable to display up to 4 of the following: target and actual values for total savings, annual savings, one time savings, cost avoidance, implementation costs, as well as number of projects and percent complete.',
					thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/lean-project-summary.png',
					categories: ['All', 'Lean Projects'],
					config: {},
					slideshowView: true,
					isActive: true,
					controller: 'leanProjectSummary',
					templateUrl: '/application/f/dashboard/widgets/lean-project-summary.html',
					isDrillDown: false,
					nonRemovable: false,
					isEditable: true,
					resolve: {
						optionBlocks: function (config) {
							if (config.optionBlocks) {
								return config.optionBlocks;
							}
						}
					}
				}
			);
	}
})();
